import { FormikProps } from "formik";
import { EasyFormSideBySide } from "../../../components/Forms/FormLayout";
import { CreateOrganisationRequest } from "../../../models/Organisation";
import getOrganisationInfoColumns from "../organisationInfoColumns";

export default function OrganisationInfoStep(props: { formikProps: FormikProps<CreateOrganisationRequest>, formPropsStuf: any }) {
    return (
        <EasyFormSideBySide
            validateOnMount
            {...props.formikProps}
            {...props.formPropsStuf}
            columns={getOrganisationInfoColumns()}
            editMode={true} />
    )
}
